export const GENDER_OPTIONS = [
  { value: '',       label: 'Unknown' },
  { value: 'male',   label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other',  label: 'Other' },
]
